import { YN } from '@/common';

export class InquiryUpdateClosedDto {
  isClosed?: YN;
}
